module.exports = __webpack_public_path__ + "img/empty03.a60d882b.svg";